/*
 * Klaviyo Tracking
 * ------------------------------------------------------------------
 * Interface for sending Klaviyo product view and add to cart
 */

window._learnq = window._learnq || [];

export function trackViewedItem(product, activeVariant) {
  if (!product || !activeVariant) {
    return;
  }

  let image;
  if (activeVariant.featured_image) {
    image = activeVariant.featured_image.src;
  }
  const price = theme.formatMoney(activeVariant.price, theme.moneyFormat);
  const compareAtPrice = theme.formatMoney(
    activeVariant.compare_at_price,
    theme.moneyFormat
  );
  const variantId = activeVariant.id;
  const item = {
    Title: `${product.title}`,
    Name: `${activeVariant.name}`,
    ProductID: `${product.id}`,
    VariantID: `${activeVariant.id}`,
    ImageURL: `${image}`,
    URL: `https://kosas.com/${product.url}?variant=${variantId}`,
    Brand: `${product.vendor}`,
    Price: `${price}`,
    CompareAtPrice: `${compareAtPrice}`,
    SKU: `${activeVariant.sku}`,
  };
  _learnq.push(['track', 'Viewed Product', item]);
  _learnq.push([
    'trackViewedItem',
    {
      Title: item.Title,
      Name: item.Name,
      ProductID: item.ProductID,
      VariantID: item.VariantID,
      ImageUrl: item.ImageURL,
      Url: item.URL,
      SKU: item.SKU,
      Metadata: {
        Brand: item.Brand,
        Price: item.Price,
        CompareAtPrice: item.CompareAtPrice,
      },
    },
  ]);
}

export function trackAddToCart(item) {
  // console.log('send klaviyo track', item);

  const price = theme.formatMoney(item.price, theme.moneyFormat);
  const compareAtPrice = theme.formatMoney(
    item.compare_at_price,
    theme.moneyFormat
  );

  const trackedItem = {
    Title: `${item.product_title}`,
    Name: `${item.title}`,
    ProductID: `${item.product_id}`,
    VariantID: `${item.id}`,
    ImageURL: `${item.image}`,
    URL: `https://kosas.com/${item.url}`,
    Brand: `${item.vendor}`,
    Price: `${price}`,
    CompareAtPrice: `${compareAtPrice}`,
    SKU: `${item.sku}`
  };
  
  _learnq.push(['track', 'Added to Cart', trackedItem]);
  // console.log(['track', 'Added to Cart', trackedItem]);
}

/*
  const customProperties = {
    'TestValue' : 'Free Trial',
    'ExampleDate' : '2016-01-27 12:10:05'
  };

  trackCustomProperties(customProperties);
*/
export function trackCustomProperties(obj) {
  _learnq.push(['identify', obj]);
  // console.log(['identify', obj]);
}